import RefreshIcon from '@/assets/Refresh';
import { GrainUsageTypeEnum } from '@/common/constants';
import { InputControl } from '@/components/controls/input-control';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { cleanObject } from '@/lib/clean-object';
import { Search } from 'lucide-react';
import { FC, Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

interface PartiesFilterProps {
  activeTab: GrainUsageTypeEnum;
}

interface IFilterProps {
  search_keyword: string;
}

const PartiesFilter: FC<PartiesFilterProps> = ({ activeTab }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const form = useForm({
    defaultValues: {
      search_keyword: searchParams.get('search_keyword') || '',
    },
    mode: 'onSubmit',
  });
  const { control, handleSubmit } = form;

  const onSubmit = async (values: IFilterProps) => {
    const param = cleanObject(values);
    setSearchParams((prev) => {
      param.search_keyword && prev.set('search_keyword', param.search_keyword);
      return prev;
    });
  };

  const onReset = () => {
    setSearchParams((prev) => {
      prev.delete('search_keyword');
      return prev;
    });
    form.reset({
      search_keyword: '',
    });
  };

  return (
    <Fragment>
      <Form {...form}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex items-center space-x-4">
            <InputControl
              control={control as any}
              name="search_keyword"
              placeholder={
                activeTab === GrainUsageTypeEnum.SEED
                  ? t('enter.party.number')
                  : t('enter.place.number')
              }
              className="w-[240px]"
            />
            <div className="flex items-center gap-3">
              <Button
                type="submit"
                className="border border-green-default bg-green-500 px-2"
              >
                <Search className="stroke-white w-5" />
              </Button>
              <Button
                variant="outline"
                onClick={onReset}
                className="shadow-none w-9 h-9 p-0"
              >
                <RefreshIcon />
              </Button>
            </div>
          </div>
        </form>
      </Form>
    </Fragment>
  );
};

export default PartiesFilter;
